// Due to hammer (2.0.8) being broken on the latest android phones,
// we are importing our version with 1 change
// SUPPORT_POINTER_EVENTS = false
import Hammer from '../hammerjs/hammer';

export default class HorizontalSlider {

  constructor(selector, {
      slideBy = 0, // Maximum number of slides to slide with 1 swipe, 0 stands for unlimited
      centerMobile = false, // Do we center on mobile
      centerTablet = false, // Do we center on tablet
      activeClass = 'active',
      onChanged = function() {},
      threshold = 20,
      desktop = true, // Is the slider running on desktop? 992px and more
      tablet = true,
      dotsSelector = false, // show the dots selector/pagination
      sliderPanelSelector = '.horizontal-slider__slider-panel',
      sliderPanelBaseDocument = false,
      margin = 0, // Do we add some margin before the items (only used when not centered)
      marginOffset = 0
    } = {}) {

    this.sliderEl = document.querySelector(selector);

    this.slideBy = slideBy;
    this.onChanged = onChanged;
    this.activeClass = activeClass;
    this.slideWidthCheck = false;
    this.sliderPanelBaseDocument = sliderPanelBaseDocument;

    let mobileBreakpoint = 575;
    let tabletBreakpoint = 992;

    // If there is no slider element, return
    if (! this.sliderEl) {
      return;
    }

    // Are we on desktop size and the slider is not for desktop? return
    // Add listener for changing windows sizes, to recheck
    if (!desktop && window.innerWidth > tabletBreakpoint) {
      return;
    }

    if (!tablet && (window.innerWidth <= tabletBreakpoint && window.innerWidth > mobileBreakpoint )) {
      return;
    }

    this.sliderPanelSelector = sliderPanelSelector;
    this.slideCount = this.sliderEl.querySelectorAll(this.sliderPanelSelector).length;

    // This slider might not be visible (tabs)
    // So we search for the first slide that is being shownn and get it's width
    this.slideWidth = this.getSliderElementWidth();

    // On window resize the slides may resize
    window.addEventListener('resize', () => {
      this.slideWidth = this.getSliderElementWidth();
      this.margin = this.calculateMargin();
      this.slideWidthCheck = false;
    }, {
      passive: true
    });

    // If there is only 1 element or less, don't slide.
    if (this.slideCount <= 1) {
      return;
    }

    // Do we center the items?
    let center = false;
    if (window.innerWidth < mobileBreakpoint && centerMobile !== false) {
      center = centerMobile;
    } else if (window.innerWidth >= mobileBreakpoint && window.innerWidth < tabletBreakpoint && centerTablet != false) {
      center = centerTablet;
    }

    this.dotsSelector = dotsSelector;

    this.sensitivity = this.slideWidth / 2 // horizontal px needed to trigger swipe

    this.activeSlide = 0;
    this.setActiveClass();

    if (center) {
      this.marginOffset = marginOffset;
      this.margin = this.calculateMargin();
    } else  {
      this.margin = margin;
    }

    this.positionX = this.margin // Initial position
    this.sliderEl.style.transform = 'translate3d(' + (this.positionX) + 'px, 0, 0)';

    // Setup  HammerJs
    this.sliderManager = new Hammer.Manager(this.sliderEl);
    this.sliderManager.add( new Hammer.Pan({ direction: Hammer.DIRECTION_HORIZONTAL, threshold: threshold, pointers: 1 }) );

    this.sliderManager.on('pan', function(e) {
		

      // Slide the slider in position based on deltaX
      this.sliderEl.style.transform = 'translate3d(' + (this.positionX + e.deltaX) + 'px, 0, 0)';

      // Snap to the slide when event is done
      if(e.isFinal) {
        // Should we move more than 1 slide?
        // If deltaX is more than half slide round up
        let nr = this.slideBy;

        if (this.slideBy == 0) {
          nr = Math.round(Math.abs(e.deltaX) / this.slideWidth);
          if (nr == 0) nr = 1;
          if (nr < 0) nr = 1;
          if (nr > 1000) nr = 1;
        }
		
        if(e.velocityX > 1) {
          this.goTo(this.activeSlide - nr);
        } else if(e.velocityX < -1) {
          this.goTo(this.activeSlide + nr);
        } else {
          if(e.deltaX <= -(this.sensitivity / this.slideCount))
            this.goTo(this.activeSlide + nr);
          else if(e.deltaX >= (this.sensitivity / this.slideCount))
            this.goTo(this.activeSlide - nr);
          else
            this.goTo(this.activeSlide);
        }
      }
    }.bind(this));

    // Go to the first slide
    this.goTo(0);
  }

  goTo(index) {
    // At the first swipe we check if the slideWidth is the same
    // If it is we skip this check (until the window is resized)
    // If it's not the slideWidth measurement was taken too quickly (this was happening locally)
	
	
    if (! this.slideWidthCheck) {
      let slideWidth = this.getSliderElementWidth();

      this.slideWidthCheck = true;

      if (this.slideWidth !== slideWidth) {
        this.slideWidth = slideWidth;
        this.margin = this.calculateMargin();
        this.slideWidthCheck = false;
      }
    }

    let currentSlide = this.activeSlide

    // Let's make sure we stay within the slides
    if (index == currentSlide) {
      return;
    }

    if (index > this.slideCount - 1) {
      this.activeSlide = this.slideCount - 1;
    } else if (index < 0) {
      this.activeSlide = 0;
    } else {
      this.activeSlide = index;
    }

    if (currentSlide != this.activeSlide){
      this.onChanged(index);
      this.setActiveClass();
    }

    // Calculate the new position on the X axis
    this.positionX = this.margin - (this.activeSlide * this.slideWidth);
    this.sliderEl.style.transform = 'translate3d( ' + this.positionX + 'px, 0, 0)';
  }

  setActiveClass() {
    let slides = this.sliderEl.querySelectorAll(this.sliderPanelSelector);

    let activeElement = this.sliderEl.querySelector('.' + this.activeClass);
    if (activeElement) {
      activeElement.classList.remove(this.activeClass);
    }

    slides[this.activeSlide].classList.add(this.activeClass);

    if (this.dotsSelector) {
      let dots = document.querySelector(this.dotsSelector);
      let items = dots.querySelectorAll('li');

      let activeDot = dots.querySelector('.' + this.activeClass);
      if (activeDot) {
        activeDot.classList.remove(this.activeClass);
      }

      items[this.activeSlide].classList.add(this.activeClass);
    }
  }

  calculateMargin() {
    if (this.margin !== 0) {
      this.margin = ((window.innerWidth - this.slideWidth) / 2) + this.marginOffset; // add margin for slide centering
      return this.margin;
    }

    return 0;
  }

  getSliderElementWidth() {
	  try {
			if (this.sliderPanelBaseDocument) {
				if (document.querySelector(this.sliderPanelSelector).offsetWidth > 0) {
					return document.querySelector(this.sliderPanelSelector).offsetWidth;
				}
			}
			return this.sliderEl.querySelector(this.sliderPanelSelector).offsetWidth;
		} catch(err) { return 0 };
  }
}